/*
 * @Author: czj
 * @Date: 2025-04-17 10:52:16
 * @Description: 应用入口 — 注册 Pinia / Router / ElementPlus / i18n / 权限指令 / 路由守卫
 * @FilePath: \kp-rag-system\src\main.js
 */

import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router/index'

import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import i18n from './locales/index'

// 注册自定义指令（v-permission）
import { registerDirectives } from '@/directives/permission'

// 激活全局路由守卫（动态路由 + 权限控制）
import '@/Permission'

// console.log = () => undefined;// 屏蔽控制台输出

const app = createApp(App)

// 注册所有 Element Plus Icons
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.use(i18n)

// 注册自定义指令
registerDirectives(app)

app.mount('#app')

export default app
